var Writaholics = Writaholics || {};

Writaholics.ResponsiveNavbar = function () {

	var logo = $(".brand-logo");

	var _init = function () {
		$('.navbar-toggler-icon').on('click', _clickHandler);
	}


	var _clickHandler = function () {
		if (!$('.topnav-wrapper').hasClass('topnav-wrapper--scrolled')) {
			$('.topnav-wrapper').addClass('topnav-wrapper--scrolled');
			logo.attr("src", "img/layout/writaholics-logo.svg").fadeIn(100);
		} else if (!$(window).scrollTop() >=1) {
			$('.topnav-wrapper').removeClass('topnav-wrapper--scrolled');
			logo.attr("src", "img/layout/writaholics-logo-light.svg").fadeIn(100);
		} else {
			$('.topnav-wrapper').addClass('topnav-wrapper--scrolled');
			logo.attr("src", "img/layout/writaholics-logo.svg").fadeIn(100);
		}
	}

	/** PUBLIC API **/
	return {
		init: function () { return _init(); }
	};

}();

jQuery(function () {
	Writaholics.ResponsiveNavbar.init();

});
